import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../state/AuthContext";
import { APP_NAME } from "../constants/app";

const AppShell = ({ title, children }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  return (
    <div className="app-shell">
      <header className="app-shell__header">
        <div>
          <p className="app-shell__eyebrow">{APP_NAME}</p>
          <h1 className="app-shell__title">{title}</h1>
        </div>

        <div className="app-shell__actions">
          <Link to="/budget-entry">Budget Entry</Link>
          <Link to="/budget-module/dashboard">Budget Module</Link>
          <button
            type="button"
            onClick={() => {
              logout();
              navigate("/login");
            }}
          >
            Sign out
          </button>
        </div>
      </header>

      <div className="app-shell__meta">
        Signed in as <strong>{user?.name || user?.email || "User"}</strong>
      </div>

      <main>{children}</main>
    </div>
  );
};

export default AppShell;
